export default "__VITE_ASSET__b6d2dd11__"